import React from "react";
import { Icon, Button } from "@amzn/meridian";
import cameraTokens from "@amzn/meridian-tokens/base/icon/camera";
import "./CaptureButton.scss";

interface CaptureButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Reusable capture button component
 * Displays camera icon for capturing photos
 */
const CaptureButton: React.FC<CaptureButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <div className="capture-button__wrapper">
      <Button
        className="capture-button"
        type="icon"
        size="xlarge"
        circular={true} onClick={onClick} aria-label="Capture Picture"
      >
        <Icon tokens={cameraTokens} />
      </Button>
    </div>
  );
};

export default CaptureButton;
